// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 12H7V10H13V12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 8H7V6H17V8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 13H23V22H1V13H3V2H21V13ZM5 13H8.90137L9.09473 13.751C9.42791 15.045 10.6036 16 12 16C13.3964 16 14.5721 15.045 14.9053 13.751L15.0986 13H19V4H5V13Z"}}]};

const DraftFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'draft-filled',
    ref,
    icon: element,
  },
));

DraftFilledIcon.displayName = 'DraftFilledIcon';

export default DraftFilledIcon;
